module.exports = __webpack_public_path__ + "static/img/2761e7523b54df80dc30fff91464a882.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index_img3.png
// module id = OQZR
// module chunks = 1